import { Cents, Instrument, Pitch } from "./music";

export interface Sound {
}

export class PitchedSound {
	constructor(public pitch: Pitch,
	            public instrument: Instrument,
	            public basePitch: Pitch,
	            public correction: Cents) {
	}
}

export class UnpitchedSound {
	constructor(public instrument: Instrument,
	            public soundName: string) {
	}
}

export let stepsToMidiNoteNumbers = {
	A: 9,
	B: 11,
	C: 0,
	D: 2,
	E: 4,
	F: 5,
	G: 7
}




// WEBPACK FOOTER //
// ./src/model/sound.ts